import React, {Component} from 'react';
import {Link, withRouter} from "react-router-dom";
import {connect} from 'react-redux';

import {Button, Form, Grid, Header, Icon, List, Message, Segment} from "semantic-ui-react";

import {
    completePasswordRecovery,
    displayValidationErrors,
    initPasswordRecoveryForm,
    requestPasswordRecovery,
    updateEmail,
    updatePassword,
    updatePasswordConfirmation
} from "../../actions/passwordRecovery";

class PasswordRecovery extends Component {

    componentDidMount() {
        this.props.dispatch(initPasswordRecoveryForm());
    }

    onChangeEmail(e) {
        this.props.dispatch(updateEmail(e.target.value));
    }

    onChangePassword(e) {
        this.props.dispatch(updatePassword(e.target.value));
    }

    onChangePasswordConfirmation(e) {
        this.props.dispatch(updatePasswordConfirmation(this.props.password, e.target.value));
    }

    onClickSend() {
        if (this.props.emailErrors.length > 0) {
            this.props.dispatch(displayValidationErrors());
        } else {
            this.props.dispatch(requestPasswordRecovery(this.props.email));
        }
    }

    onClickReset() {
        if (this.props.passwordErrors.length > 0
            || this.props.passwordConfirmationErrors.length > 0) {
            this.props.dispatch(displayValidationErrors());
        } else {
            this.props.dispatch(completePasswordRecovery(this.props.match.params.token, this.props.password));
        }
    }

    render() {
        return (
            <Grid style={{height: "100%"}} textAlign="center" verticalAlign="middle">
                <Grid.Column style={{maxWidth: 450}}>
                    <Segment.Group>
                        <Segment>
                            <Header as="h3">
                                <Icon name="key"/>
                                <Header.Content>Resetowanie hasła</Header.Content>
                            </Header>
                        </Segment>
                        {this.props.match.params.token && <Segment>
                            <Form>
                                <p style={{textAlign: "left"}}>Ustaw nowe hasło użytkownika</p>
                                <Form.Input
                                    type="password"
                                    icon="key"
                                    iconPosition="left"
                                    placeholder="Hasło"
                                    disabled={this.props.resetting || this.props.resettingCompleted}
                                    value={this.props.password}
                                    onChange={(e) => {
                                        this.onChangePassword(e)
                                    }}/>
                                {this.props.formErrorsVisible && <List style={{color: "#9f3a38", textAlign: "left"}}>
                                    {this.props.passwordErrors.map((error, index) => <List.Item
                                        key={index}>{error}</List.Item>)}
                                </List>}
                                <Form.Input
                                    type="password"
                                    icon="key"
                                    iconPosition="left"
                                    placeholder="Potwierdzenie hasła"
                                    disabled={this.props.resetting || this.props.resettingCompleted}
                                    value={this.props.passwordConfirmation}
                                    onChange={(e) => {
                                        this.onChangePasswordConfirmation(e)
                                    }}/>
                                {this.props.formErrorsVisible && <List style={{color: "#9f3a38", textAlign: "left"}}>
                                    {this.props.passwordConfirmationErrors.map((error, index) => <List.Item
                                        key={index}>{error}</List.Item>)}
                                </List>}
                                {this.props.resettingCompleted && <Message positive icon>
                                    <Icon name="mail"/>
                                    <Message.Content style={{textAlign: "left"}}>
                                        Nowe hasło zostało ustawione. <Link to="/zgloszenia/logowanie">Zaloguj
                                        się!</Link>
                                    </Message.Content>
                                </Message>}
                                {this.props.resettingFailed && <Message negative icon>
                                    <Icon name="exclamation triangle"/>
                                    <Message.Content style={{textAlign: "left"}}>
                                        Nie udało się ustawić hasła użytkownika. Skontaktuj się z administratorem aby
                                        uzyskać więcej informacji.
                                    </Message.Content>
                                </Message>}
                                <Button
                                    primary
                                    disabled={this.props.resetting || this.props.resettingCompleted}
                                    loading={this.props.resetting}
                                    onClick={(e) => {
                                        this.onClickReset(e)
                                    }}>Ustaw hasło</Button>
                            </Form>
                        </Segment>}
                        {!this.props.match.params.token && <Segment>
                            <Form>
                                <p style={{textAlign: "left"}}>Podaj adres e-mail użytkownika dla którego chcesz
                                    zresetować hasło.</p>
                                <Form.Input
                                    icon="mail"
                                    iconPosition="left"
                                    placeholder="E-mail"
                                    disabled={this.props.sending || this.props.sendingCompleted}
                                    value={this.props.email}
                                    onChange={(e) => {
                                        this.onChangeEmail(e)
                                    }}/>
                                {this.props.formErrorsVisible && <List style={{color: "#9f3a38", textAlign: "left"}}>
                                    {this.props.emailErrors.map((error, index) => <List.Item
                                        key={index}>{error}</List.Item>)}
                                </List>}
                                {this.props.sendingCompleted && <Message positive icon>
                                    <Icon name="mail"/>
                                    <Message.Content style={{textAlign: "left"}}>
                                        Żeby ustawić nowe hasło użyj linku wysłanego na podany adres e-mail.
                                    </Message.Content>
                                </Message>}
                                {this.props.sendingFailed && <Message negative icon>
                                    <Icon name="exclamation triangle"/>
                                    <Message.Content style={{textAlign: "left"}}>
                                        Nie udało się zresetować hasła dla wskazanego adresu email. Skontaktuj się z
                                        administratorem aby uzyskać więcej informacji.
                                    </Message.Content>
                                </Message>}
                                <Button
                                    primary
                                    disabled={this.props.sending || this.props.sendingCompleted}
                                    loading={this.props.sending}
                                    onClick={(e) => {
                                        this.onClickSend(e)
                                    }}>Wyślij</Button>
                            </Form>
                        </Segment>}
                        {!this.props.match.params.token && <Segment>
                            <p>Masz juz konto? {!this.props.sending &&
                            <Link to="/logowanie">Zaloguj się!</Link>}{this.props.sending &&
                            <span>Zaloguj się!</span>}</p>
                            <p>Nie masz konta? {!this.props.sending &&
                            <Link to="/rejestracja">Zarejestruj się!</Link>}{this.props.sending &&
                            <span>Zarejestruj się!</span>}</p>
                        </Segment>}
                    </Segment.Group>
                </Grid.Column>
            </Grid>
        );
    }
};

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        email: state.passwordRecovery.email,
        emailErrors: state.passwordRecovery.emailErrors,
        password: state.passwordRecovery.password,
        passwordErrors: state.passwordRecovery.passwordErrors,
        passwordConfirmation: state.passwordRecovery.passwordConfirmation,
        passwordConfirmationErrors: state.passwordRecovery.passwordConfirmationErrors,
        sending: state.passwordRecovery.sending,
        sendingFailed: state.passwordRecovery.sendingFailed,
        sendingError: state.passwordRecovery.sendingError,
        sendingCompleted: state.passwordRecovery.sendingCompleted,
        resetting: state.passwordRecovery.resetting,
        resettingFailed: state.passwordRecovery.resettingFailed,
        resettingError: state.passwordRecovery.resettingError,
        resettingCompleted: state.passwordRecovery.resettingCompleted,
        formErrorsVisible: state.passwordRecovery.formErrorsVisible
    }
}

export default withRouter(connect(mapStateToProps)(PasswordRecovery))



// WEBPACK FOOTER //
// ./src/components/routes/PasswordRecovery.js